export default __webpack_public_path__ + "static/media/IMG0081.1bf782c7.jpg";